module.exports = __webpack_public_path__ + "static/media/ebook.adf91b82.jpeg";